import { Directive, NgModule } from '@angular/core';

@Directive({
  selector: '[pgCardRightCol]',
})
export class PgCardRightColumnDirective {}
@Directive({
  selector: '[pgCardSubtitle]',
})
export class PgCardSubtitleDirective {}

@Directive({
  selector: '[pgCardPreviewTitle]',
})
export class PgCardPreviewTitleDirective {}

@Directive({
  selector: '[pgCardExpandedTitle]',
})
export class PgCardExpandedTitleDirective {}

@Directive({
  selector: '[pgCardExpandedContent]',
})
export class PgCardExpandedContentDirective {}

@NgModule({
  declarations: [
    PgCardSubtitleDirective,
    PgCardPreviewTitleDirective,
    PgCardExpandedTitleDirective,
    PgCardExpandedContentDirective,
    PgCardRightColumnDirective,
  ],
  exports: [
    PgCardSubtitleDirective,
    PgCardPreviewTitleDirective,
    PgCardExpandedTitleDirective,
    PgCardExpandedContentDirective,
    PgCardRightColumnDirective,
  ],
})
export class PgReapplyCardDirectiveModule {}
